var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7501 3.6665V19.4998C23.7501 21.2415 22.3251 22.6665 20.5834 22.6665H3.16675V9.99984C3.16675 6.50067 6.00091 3.6665 9.50008 3.6665H23.7501Z",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8334 22.6665V27.4165C34.8334 30.0448 32.7118 32.1665 30.0834 32.1665H28.5001C28.5001 30.4248 27.0751 28.9998 25.3334 28.9998C23.5918 28.9998 22.1667 30.4248 22.1667 32.1665H15.8334C15.8334 30.4248 14.4084 28.9998 12.6667 28.9998C10.9251 28.9998 9.50008 30.4248 9.50008 32.1665H7.91675C5.28841 32.1665 3.16675 30.0448 3.16675 27.4165V22.6665H20.5834C22.3251 22.6665 23.7501 21.2415 23.7501 19.4998V8.4165H26.6634C27.8034 8.4165 28.8484 9.03402 29.4184 10.0157L32.1259 14.7498H30.0834C29.2126 14.7498 28.5001 15.4623 28.5001 16.3332V21.0832C28.5001 21.954 29.2126 22.6665 30.0834 22.6665H34.8334Z",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 35.3333C14.4156 35.3333 15.8333 33.9156 15.8333 32.1667C15.8333 30.4178 14.4156 29 12.6667 29C10.9178 29 9.5 30.4178 9.5 32.1667C9.5 33.9156 10.9178 35.3333 12.6667 35.3333Z",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 35.3333C27.0823 35.3333 28.5001 33.9156 28.5001 32.1667C28.5001 30.4178 27.0823 29 25.3334 29C23.5845 29 22.1667 30.4178 22.1667 32.1667C22.1667 33.9156 23.5845 35.3333 25.3334 35.3333Z",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 19.5V22.6667H30.0833C29.2125 22.6667 28.5 21.9542 28.5 21.0833V16.3333C28.5 15.4625 29.2125 14.75 30.0833 14.75H32.1258L34.8333 19.5Z",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatCircle);
export default __webpack_public_path__ + "cceafff96ef024726e10f962bb6a1a65.svg";
export { ForwardRef as ReactComponent };